"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.10
//   protoc               v6.33.5
// source: protos/charger.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientCertAuthentication = exports.BasicAuthentication = exports.MembershipValidation = exports.DEMO = exports.COSTCO = exports.ChargerUiConfig = exports.UiConfig_PerChargerEntry = exports.UiConfig = exports.Theme = exports.PerChargerUiConfig = exports.PlugShareCTA = exports.GoogleReviewCTA = exports.ReceiptCallToAction = exports.reportedFeedbackIssueToJSON = exports.reportedFeedbackIssueFromJSON = exports.ReportedFeedbackIssue = exports.unavailableReasonToJSON = exports.unavailableReasonFromJSON = exports.UnavailableReason = exports.ocppChargingStateToJSON = exports.ocppChargingStateFromJSON = exports.OcppChargingState = exports.paymentEnvironmentToJSON = exports.paymentEnvironmentFromJSON = exports.PaymentEnvironment = exports.portTypeToJSON = exports.portTypeFromJSON = exports.PortType = exports.protobufPackage = void 0;
/* eslint-disable */
const wire_1 = require("@bufbuild/protobuf/wire");
exports.protobufPackage = "charger";
/** The type of port. */
var PortType;
(function (PortType) {
    PortType[PortType["CCS"] = 0] = "CCS";
    PortType[PortType["CHADEMO"] = 1] = "CHADEMO";
    PortType[PortType["NACS"] = 2] = "NACS";
    PortType[PortType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(PortType = exports.PortType || (exports.PortType = {}));
function portTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "CCS":
            return PortType.CCS;
        case 1:
        case "CHADEMO":
            return PortType.CHADEMO;
        case 2:
        case "NACS":
            return PortType.NACS;
        case -1:
        case "UNRECOGNIZED":
        default:
            return PortType.UNRECOGNIZED;
    }
}
exports.portTypeFromJSON = portTypeFromJSON;
function portTypeToJSON(object) {
    switch (object) {
        case PortType.CCS:
            return "CCS";
        case PortType.CHADEMO:
            return "CHADEMO";
        case PortType.NACS:
            return "NACS";
        case PortType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.portTypeToJSON = portTypeToJSON;
/** The payment environment for a charger. */
var PaymentEnvironment;
(function (PaymentEnvironment) {
    PaymentEnvironment[PaymentEnvironment["LIVE"] = 0] = "LIVE";
    PaymentEnvironment[PaymentEnvironment["TEST"] = 1] = "TEST";
    PaymentEnvironment[PaymentEnvironment["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(PaymentEnvironment = exports.PaymentEnvironment || (exports.PaymentEnvironment = {}));
function paymentEnvironmentFromJSON(object) {
    switch (object) {
        case 0:
        case "LIVE":
            return PaymentEnvironment.LIVE;
        case 1:
        case "TEST":
            return PaymentEnvironment.TEST;
        case -1:
        case "UNRECOGNIZED":
        default:
            return PaymentEnvironment.UNRECOGNIZED;
    }
}
exports.paymentEnvironmentFromJSON = paymentEnvironmentFromJSON;
function paymentEnvironmentToJSON(object) {
    switch (object) {
        case PaymentEnvironment.LIVE:
            return "LIVE";
        case PaymentEnvironment.TEST:
            return "TEST";
        case PaymentEnvironment.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.paymentEnvironmentToJSON = paymentEnvironmentToJSON;
/**
 * The OCPP 2.0.1 ChargingStateEnumType reported for a transaction (see
 * TransactionEventRequest.transactionInfo.chargingState). Populated now that chargers have moved
 * from OCPP 1.6 to 2.0.1, reported alongside a port's existing OCPP connector status.
 */
var OcppChargingState;
(function (OcppChargingState) {
    OcppChargingState[OcppChargingState["OCPP_CHARGING_STATE_UNKNOWN"] = 0] = "OCPP_CHARGING_STATE_UNKNOWN";
    OcppChargingState[OcppChargingState["OCPP_CHARGING_STATE_EV_CONNECTED"] = 1] = "OCPP_CHARGING_STATE_EV_CONNECTED";
    OcppChargingState[OcppChargingState["OCPP_CHARGING_STATE_CHARGING"] = 2] = "OCPP_CHARGING_STATE_CHARGING";
    OcppChargingState[OcppChargingState["OCPP_CHARGING_STATE_SUSPENDED_EV"] = 3] = "OCPP_CHARGING_STATE_SUSPENDED_EV";
    OcppChargingState[OcppChargingState["OCPP_CHARGING_STATE_SUSPENDED_EVSE"] = 4] = "OCPP_CHARGING_STATE_SUSPENDED_EVSE";
    OcppChargingState[OcppChargingState["OCPP_CHARGING_STATE_IDLE"] = 5] = "OCPP_CHARGING_STATE_IDLE";
    OcppChargingState[OcppChargingState["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(OcppChargingState = exports.OcppChargingState || (exports.OcppChargingState = {}));
function ocppChargingStateFromJSON(object) {
    switch (object) {
        case 0:
        case "OCPP_CHARGING_STATE_UNKNOWN":
            return OcppChargingState.OCPP_CHARGING_STATE_UNKNOWN;
        case 1:
        case "OCPP_CHARGING_STATE_EV_CONNECTED":
            return OcppChargingState.OCPP_CHARGING_STATE_EV_CONNECTED;
        case 2:
        case "OCPP_CHARGING_STATE_CHARGING":
            return OcppChargingState.OCPP_CHARGING_STATE_CHARGING;
        case 3:
        case "OCPP_CHARGING_STATE_SUSPENDED_EV":
            return OcppChargingState.OCPP_CHARGING_STATE_SUSPENDED_EV;
        case 4:
        case "OCPP_CHARGING_STATE_SUSPENDED_EVSE":
            return OcppChargingState.OCPP_CHARGING_STATE_SUSPENDED_EVSE;
        case 5:
        case "OCPP_CHARGING_STATE_IDLE":
            return OcppChargingState.OCPP_CHARGING_STATE_IDLE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return OcppChargingState.UNRECOGNIZED;
    }
}
exports.ocppChargingStateFromJSON = ocppChargingStateFromJSON;
function ocppChargingStateToJSON(object) {
    switch (object) {
        case OcppChargingState.OCPP_CHARGING_STATE_UNKNOWN:
            return "OCPP_CHARGING_STATE_UNKNOWN";
        case OcppChargingState.OCPP_CHARGING_STATE_EV_CONNECTED:
            return "OCPP_CHARGING_STATE_EV_CONNECTED";
        case OcppChargingState.OCPP_CHARGING_STATE_CHARGING:
            return "OCPP_CHARGING_STATE_CHARGING";
        case OcppChargingState.OCPP_CHARGING_STATE_SUSPENDED_EV:
            return "OCPP_CHARGING_STATE_SUSPENDED_EV";
        case OcppChargingState.OCPP_CHARGING_STATE_SUSPENDED_EVSE:
            return "OCPP_CHARGING_STATE_SUSPENDED_EVSE";
        case OcppChargingState.OCPP_CHARGING_STATE_IDLE:
            return "OCPP_CHARGING_STATE_IDLE";
        case OcppChargingState.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.ocppChargingStateToJSON = ocppChargingStateToJSON;
var UnavailableReason;
(function (UnavailableReason) {
    UnavailableReason[UnavailableReason["NONE"] = 0] = "NONE";
    /** CONNECTORS_UNAVAILABLE - DEPRECATED: use CONNECTOR_UNAVAILABLE */
    UnavailableReason[UnavailableReason["CONNECTORS_UNAVAILABLE"] = 1] = "CONNECTORS_UNAVAILABLE";
    UnavailableReason[UnavailableReason["OCPP_DISCONNECTED"] = 2] = "OCPP_DISCONNECTED";
    UnavailableReason[UnavailableReason["PAYMENTS_NOT_READY"] = 3] = "PAYMENTS_NOT_READY";
    UnavailableReason[UnavailableReason["CHARGER_DISABLED"] = 4] = "CHARGER_DISABLED";
    UnavailableReason[UnavailableReason["POWERNODE_OFFLINE"] = 5] = "POWERNODE_OFFLINE";
    UnavailableReason[UnavailableReason["ESTOP_PRESSED"] = 6] = "ESTOP_PRESSED";
    UnavailableReason[UnavailableReason["PN_CONTROL_DISCONNECTED"] = 8] = "PN_CONTROL_DISCONNECTED";
    /** ALL_PORTS_FAULTED_AND_UNPLUGGED - DEPRECATED: use PORT_FAULTED_AND_UNPLUGGED */
    UnavailableReason[UnavailableReason["ALL_PORTS_FAULTED_AND_UNPLUGGED"] = 7] = "ALL_PORTS_FAULTED_AND_UNPLUGGED";
    UnavailableReason[UnavailableReason["SOFTWARE_UPDATE_IN_PROGRESS"] = 9] = "SOFTWARE_UPDATE_IN_PROGRESS";
    UnavailableReason[UnavailableReason["PORT_FAULTED_AND_UNPLUGGED"] = 10] = "PORT_FAULTED_AND_UNPLUGGED";
    UnavailableReason[UnavailableReason["CONNECTOR_UNAVAILABLE"] = 11] = "CONNECTOR_UNAVAILABLE";
    UnavailableReason[UnavailableReason["PORT_DISABLED"] = 12] = "PORT_DISABLED";
    UnavailableReason[UnavailableReason["CHARGER_UI_LOC"] = 13] = "CHARGER_UI_LOC";
    UnavailableReason[UnavailableReason["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(UnavailableReason = exports.UnavailableReason || (exports.UnavailableReason = {}));
function unavailableReasonFromJSON(object) {
    switch (object) {
        case 0:
        case "NONE":
            return UnavailableReason.NONE;
        case 1:
        case "CONNECTORS_UNAVAILABLE":
            return UnavailableReason.CONNECTORS_UNAVAILABLE;
        case 2:
        case "OCPP_DISCONNECTED":
            return UnavailableReason.OCPP_DISCONNECTED;
        case 3:
        case "PAYMENTS_NOT_READY":
            return UnavailableReason.PAYMENTS_NOT_READY;
        case 4:
        case "CHARGER_DISABLED":
            return UnavailableReason.CHARGER_DISABLED;
        case 5:
        case "POWERNODE_OFFLINE":
            return UnavailableReason.POWERNODE_OFFLINE;
        case 6:
        case "ESTOP_PRESSED":
            return UnavailableReason.ESTOP_PRESSED;
        case 8:
        case "PN_CONTROL_DISCONNECTED":
            return UnavailableReason.PN_CONTROL_DISCONNECTED;
        case 7:
        case "ALL_PORTS_FAULTED_AND_UNPLUGGED":
            return UnavailableReason.ALL_PORTS_FAULTED_AND_UNPLUGGED;
        case 9:
        case "SOFTWARE_UPDATE_IN_PROGRESS":
            return UnavailableReason.SOFTWARE_UPDATE_IN_PROGRESS;
        case 10:
        case "PORT_FAULTED_AND_UNPLUGGED":
            return UnavailableReason.PORT_FAULTED_AND_UNPLUGGED;
        case 11:
        case "CONNECTOR_UNAVAILABLE":
            return UnavailableReason.CONNECTOR_UNAVAILABLE;
        case 12:
        case "PORT_DISABLED":
            return UnavailableReason.PORT_DISABLED;
        case 13:
        case "CHARGER_UI_LOC":
            return UnavailableReason.CHARGER_UI_LOC;
        case -1:
        case "UNRECOGNIZED":
        default:
            return UnavailableReason.UNRECOGNIZED;
    }
}
exports.unavailableReasonFromJSON = unavailableReasonFromJSON;
function unavailableReasonToJSON(object) {
    switch (object) {
        case UnavailableReason.NONE:
            return "NONE";
        case UnavailableReason.CONNECTORS_UNAVAILABLE:
            return "CONNECTORS_UNAVAILABLE";
        case UnavailableReason.OCPP_DISCONNECTED:
            return "OCPP_DISCONNECTED";
        case UnavailableReason.PAYMENTS_NOT_READY:
            return "PAYMENTS_NOT_READY";
        case UnavailableReason.CHARGER_DISABLED:
            return "CHARGER_DISABLED";
        case UnavailableReason.POWERNODE_OFFLINE:
            return "POWERNODE_OFFLINE";
        case UnavailableReason.ESTOP_PRESSED:
            return "ESTOP_PRESSED";
        case UnavailableReason.PN_CONTROL_DISCONNECTED:
            return "PN_CONTROL_DISCONNECTED";
        case UnavailableReason.ALL_PORTS_FAULTED_AND_UNPLUGGED:
            return "ALL_PORTS_FAULTED_AND_UNPLUGGED";
        case UnavailableReason.SOFTWARE_UPDATE_IN_PROGRESS:
            return "SOFTWARE_UPDATE_IN_PROGRESS";
        case UnavailableReason.PORT_FAULTED_AND_UNPLUGGED:
            return "PORT_FAULTED_AND_UNPLUGGED";
        case UnavailableReason.CONNECTOR_UNAVAILABLE:
            return "CONNECTOR_UNAVAILABLE";
        case UnavailableReason.PORT_DISABLED:
            return "PORT_DISABLED";
        case UnavailableReason.CHARGER_UI_LOC:
            return "CHARGER_UI_LOC";
        case UnavailableReason.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.unavailableReasonToJSON = unavailableReasonToJSON;
/** Feedback collected from a driver. */
var ReportedFeedbackIssue;
(function (ReportedFeedbackIssue) {
    ReportedFeedbackIssue[ReportedFeedbackIssue["NO_ISSUE"] = 0] = "NO_ISSUE";
    ReportedFeedbackIssue[ReportedFeedbackIssue["CHARGER_DAMAGED"] = 1] = "CHARGER_DAMAGED";
    ReportedFeedbackIssue[ReportedFeedbackIssue["MULTIPLE_CHARGING_ATTEMPTS"] = 2] = "MULTIPLE_CHARGING_ATTEMPTS";
    ReportedFeedbackIssue[ReportedFeedbackIssue["SCREEN_LOW_VISIBILITY"] = 3] = "SCREEN_LOW_VISIBILITY";
    ReportedFeedbackIssue[ReportedFeedbackIssue["NON_EV_BLOCKING_CHARGING"] = 4] = "NON_EV_BLOCKING_CHARGING";
    ReportedFeedbackIssue[ReportedFeedbackIssue["PROPERTY_DIRTY"] = 5] = "PROPERTY_DIRTY";
    ReportedFeedbackIssue[ReportedFeedbackIssue["PROPERTY_DEFACED"] = 6] = "PROPERTY_DEFACED";
    ReportedFeedbackIssue[ReportedFeedbackIssue["SLOW_CHARGING"] = 7] = "SLOW_CHARGING";
    ReportedFeedbackIssue[ReportedFeedbackIssue["LONG_WAIT"] = 8] = "LONG_WAIT";
    ReportedFeedbackIssue[ReportedFeedbackIssue["CHARGER_APPEARED_OFFLINE"] = 9] = "CHARGER_APPEARED_OFFLINE";
    ReportedFeedbackIssue[ReportedFeedbackIssue["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ReportedFeedbackIssue = exports.ReportedFeedbackIssue || (exports.ReportedFeedbackIssue = {}));
function reportedFeedbackIssueFromJSON(object) {
    switch (object) {
        case 0:
        case "NO_ISSUE":
            return ReportedFeedbackIssue.NO_ISSUE;
        case 1:
        case "CHARGER_DAMAGED":
            return ReportedFeedbackIssue.CHARGER_DAMAGED;
        case 2:
        case "MULTIPLE_CHARGING_ATTEMPTS":
            return ReportedFeedbackIssue.MULTIPLE_CHARGING_ATTEMPTS;
        case 3:
        case "SCREEN_LOW_VISIBILITY":
            return ReportedFeedbackIssue.SCREEN_LOW_VISIBILITY;
        case 4:
        case "NON_EV_BLOCKING_CHARGING":
            return ReportedFeedbackIssue.NON_EV_BLOCKING_CHARGING;
        case 5:
        case "PROPERTY_DIRTY":
            return ReportedFeedbackIssue.PROPERTY_DIRTY;
        case 6:
        case "PROPERTY_DEFACED":
            return ReportedFeedbackIssue.PROPERTY_DEFACED;
        case 7:
        case "SLOW_CHARGING":
            return ReportedFeedbackIssue.SLOW_CHARGING;
        case 8:
        case "LONG_WAIT":
            return ReportedFeedbackIssue.LONG_WAIT;
        case 9:
        case "CHARGER_APPEARED_OFFLINE":
            return ReportedFeedbackIssue.CHARGER_APPEARED_OFFLINE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return ReportedFeedbackIssue.UNRECOGNIZED;
    }
}
exports.reportedFeedbackIssueFromJSON = reportedFeedbackIssueFromJSON;
function reportedFeedbackIssueToJSON(object) {
    switch (object) {
        case ReportedFeedbackIssue.NO_ISSUE:
            return "NO_ISSUE";
        case ReportedFeedbackIssue.CHARGER_DAMAGED:
            return "CHARGER_DAMAGED";
        case ReportedFeedbackIssue.MULTIPLE_CHARGING_ATTEMPTS:
            return "MULTIPLE_CHARGING_ATTEMPTS";
        case ReportedFeedbackIssue.SCREEN_LOW_VISIBILITY:
            return "SCREEN_LOW_VISIBILITY";
        case ReportedFeedbackIssue.NON_EV_BLOCKING_CHARGING:
            return "NON_EV_BLOCKING_CHARGING";
        case ReportedFeedbackIssue.PROPERTY_DIRTY:
            return "PROPERTY_DIRTY";
        case ReportedFeedbackIssue.PROPERTY_DEFACED:
            return "PROPERTY_DEFACED";
        case ReportedFeedbackIssue.SLOW_CHARGING:
            return "SLOW_CHARGING";
        case ReportedFeedbackIssue.LONG_WAIT:
            return "LONG_WAIT";
        case ReportedFeedbackIssue.CHARGER_APPEARED_OFFLINE:
            return "CHARGER_APPEARED_OFFLINE";
        case ReportedFeedbackIssue.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.reportedFeedbackIssueToJSON = reportedFeedbackIssueToJSON;
function createBaseReceiptCallToAction() {
    return { googleReview: undefined, plugshareReview: undefined };
}
exports.ReceiptCallToAction = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.googleReview !== undefined) {
            exports.GoogleReviewCTA.encode(message.googleReview, writer.uint32(10).fork()).join();
        }
        if (message.plugshareReview !== undefined) {
            exports.PlugShareCTA.encode(message.plugshareReview, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseReceiptCallToAction();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.googleReview = exports.GoogleReviewCTA.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.plugshareReview = exports.PlugShareCTA.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            googleReview: isSet(object.googleReview)
                ? exports.GoogleReviewCTA.fromJSON(object.googleReview)
                : isSet(object.google_review)
                    ? exports.GoogleReviewCTA.fromJSON(object.google_review)
                    : undefined,
            plugshareReview: isSet(object.plugshareReview)
                ? exports.PlugShareCTA.fromJSON(object.plugshareReview)
                : isSet(object.plugshare_review)
                    ? exports.PlugShareCTA.fromJSON(object.plugshare_review)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.googleReview !== undefined) {
            obj.googleReview = exports.GoogleReviewCTA.toJSON(message.googleReview);
        }
        if (message.plugshareReview !== undefined) {
            obj.plugshareReview = exports.PlugShareCTA.toJSON(message.plugshareReview);
        }
        return obj;
    },
    create(base) {
        return exports.ReceiptCallToAction.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseReceiptCallToAction();
        message.googleReview =
            object.googleReview !== undefined && object.googleReview !== null
                ? exports.GoogleReviewCTA.fromPartial(object.googleReview)
                : undefined;
        message.plugshareReview =
            object.plugshareReview !== undefined && object.plugshareReview !== null
                ? exports.PlugShareCTA.fromPartial(object.plugshareReview)
                : undefined;
        return message;
    },
};
function createBaseGoogleReviewCTA() {
    return { placeId: "", baseUrl: "" };
}
exports.GoogleReviewCTA = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.placeId !== "") {
            writer.uint32(10).string(message.placeId);
        }
        if (message.baseUrl !== "") {
            writer.uint32(18).string(message.baseUrl);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGoogleReviewCTA();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.placeId = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.baseUrl = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            placeId: isSet(object.placeId)
                ? globalThis.String(object.placeId)
                : isSet(object.place_id)
                    ? globalThis.String(object.place_id)
                    : "",
            baseUrl: isSet(object.baseUrl)
                ? globalThis.String(object.baseUrl)
                : isSet(object.base_url)
                    ? globalThis.String(object.base_url)
                    : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.placeId !== "") {
            obj.placeId = message.placeId;
        }
        if (message.baseUrl !== "") {
            obj.baseUrl = message.baseUrl;
        }
        return obj;
    },
    create(base) {
        return exports.GoogleReviewCTA.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGoogleReviewCTA();
        message.placeId = object.placeId ?? "";
        message.baseUrl = object.baseUrl ?? "";
        return message;
    },
};
function createBasePlugShareCTA() {
    return { locationId: "", baseUrl: "" };
}
exports.PlugShareCTA = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.locationId !== "") {
            writer.uint32(10).string(message.locationId);
        }
        if (message.baseUrl !== "") {
            writer.uint32(18).string(message.baseUrl);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlugShareCTA();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.locationId = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.baseUrl = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            locationId: isSet(object.locationId)
                ? globalThis.String(object.locationId)
                : isSet(object.location_id)
                    ? globalThis.String(object.location_id)
                    : "",
            baseUrl: isSet(object.baseUrl)
                ? globalThis.String(object.baseUrl)
                : isSet(object.base_url)
                    ? globalThis.String(object.base_url)
                    : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.locationId !== "") {
            obj.locationId = message.locationId;
        }
        if (message.baseUrl !== "") {
            obj.baseUrl = message.baseUrl;
        }
        return obj;
    },
    create(base) {
        return exports.PlugShareCTA.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlugShareCTA();
        message.locationId = object.locationId ?? "";
        message.baseUrl = object.baseUrl ?? "";
        return message;
    },
};
function createBasePerChargerUiConfig() {
    return { customUiConfig: "" };
}
exports.PerChargerUiConfig = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.customUiConfig !== "") {
            writer.uint32(10).string(message.customUiConfig);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePerChargerUiConfig();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.customUiConfig = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            customUiConfig: isSet(object.customUiConfig)
                ? globalThis.String(object.customUiConfig)
                : isSet(object.custom_ui_config)
                    ? globalThis.String(object.custom_ui_config)
                    : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.customUiConfig !== "") {
            obj.customUiConfig = message.customUiConfig;
        }
        return obj;
    },
    create(base) {
        return exports.PerChargerUiConfig.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePerChargerUiConfig();
        message.customUiConfig = object.customUiConfig ?? "";
        return message;
    },
};
function createBaseTheme() {
    return {
        primaryBrandColorHex: "",
        secondaryBrandColorHex: "",
        chargeGaugeBrandColorHex: "",
        backgroundImageUrl: "",
        videoContentUrl: "",
        logoImageUrl: "",
        waitingGraphicUrl: "",
        staticExperienceIframeUrl: "",
    };
}
exports.Theme = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.primaryBrandColorHex !== "") {
            writer.uint32(10).string(message.primaryBrandColorHex);
        }
        if (message.secondaryBrandColorHex !== "") {
            writer.uint32(18).string(message.secondaryBrandColorHex);
        }
        if (message.chargeGaugeBrandColorHex !== "") {
            writer.uint32(26).string(message.chargeGaugeBrandColorHex);
        }
        if (message.backgroundImageUrl !== "") {
            writer.uint32(34).string(message.backgroundImageUrl);
        }
        if (message.videoContentUrl !== "") {
            writer.uint32(42).string(message.videoContentUrl);
        }
        if (message.logoImageUrl !== "") {
            writer.uint32(50).string(message.logoImageUrl);
        }
        if (message.waitingGraphicUrl !== "") {
            writer.uint32(58).string(message.waitingGraphicUrl);
        }
        if (message.staticExperienceIframeUrl !== "") {
            writer.uint32(66).string(message.staticExperienceIframeUrl);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTheme();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.primaryBrandColorHex = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.secondaryBrandColorHex = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.chargeGaugeBrandColorHex = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.backgroundImageUrl = reader.string();
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.videoContentUrl = reader.string();
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.logoImageUrl = reader.string();
                    continue;
                }
                case 7: {
                    if (tag !== 58) {
                        break;
                    }
                    message.waitingGraphicUrl = reader.string();
                    continue;
                }
                case 8: {
                    if (tag !== 66) {
                        break;
                    }
                    message.staticExperienceIframeUrl = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            primaryBrandColorHex: isSet(object.primaryBrandColorHex)
                ? globalThis.String(object.primaryBrandColorHex)
                : isSet(object.primary_brand_color_hex)
                    ? globalThis.String(object.primary_brand_color_hex)
                    : "",
            secondaryBrandColorHex: isSet(object.secondaryBrandColorHex)
                ? globalThis.String(object.secondaryBrandColorHex)
                : isSet(object.secondary_brand_color_hex)
                    ? globalThis.String(object.secondary_brand_color_hex)
                    : "",
            chargeGaugeBrandColorHex: isSet(object.chargeGaugeBrandColorHex)
                ? globalThis.String(object.chargeGaugeBrandColorHex)
                : isSet(object.charge_gauge_brand_color_hex)
                    ? globalThis.String(object.charge_gauge_brand_color_hex)
                    : "",
            backgroundImageUrl: isSet(object.backgroundImageUrl)
                ? globalThis.String(object.backgroundImageUrl)
                : isSet(object.background_image_url)
                    ? globalThis.String(object.background_image_url)
                    : "",
            videoContentUrl: isSet(object.videoContentUrl)
                ? globalThis.String(object.videoContentUrl)
                : isSet(object.video_content_url)
                    ? globalThis.String(object.video_content_url)
                    : "",
            logoImageUrl: isSet(object.logoImageUrl)
                ? globalThis.String(object.logoImageUrl)
                : isSet(object.logo_image_url)
                    ? globalThis.String(object.logo_image_url)
                    : "",
            waitingGraphicUrl: isSet(object.waitingGraphicUrl)
                ? globalThis.String(object.waitingGraphicUrl)
                : isSet(object.waiting_graphic_url)
                    ? globalThis.String(object.waiting_graphic_url)
                    : "",
            staticExperienceIframeUrl: isSet(object.staticExperienceIframeUrl)
                ? globalThis.String(object.staticExperienceIframeUrl)
                : isSet(object.static_experience_iframe_url)
                    ? globalThis.String(object.static_experience_iframe_url)
                    : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryBrandColorHex !== "") {
            obj.primaryBrandColorHex = message.primaryBrandColorHex;
        }
        if (message.secondaryBrandColorHex !== "") {
            obj.secondaryBrandColorHex = message.secondaryBrandColorHex;
        }
        if (message.chargeGaugeBrandColorHex !== "") {
            obj.chargeGaugeBrandColorHex = message.chargeGaugeBrandColorHex;
        }
        if (message.backgroundImageUrl !== "") {
            obj.backgroundImageUrl = message.backgroundImageUrl;
        }
        if (message.videoContentUrl !== "") {
            obj.videoContentUrl = message.videoContentUrl;
        }
        if (message.logoImageUrl !== "") {
            obj.logoImageUrl = message.logoImageUrl;
        }
        if (message.waitingGraphicUrl !== "") {
            obj.waitingGraphicUrl = message.waitingGraphicUrl;
        }
        if (message.staticExperienceIframeUrl !== "") {
            obj.staticExperienceIframeUrl = message.staticExperienceIframeUrl;
        }
        return obj;
    },
    create(base) {
        return exports.Theme.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTheme();
        message.primaryBrandColorHex = object.primaryBrandColorHex ?? "";
        message.secondaryBrandColorHex = object.secondaryBrandColorHex ?? "";
        message.chargeGaugeBrandColorHex = object.chargeGaugeBrandColorHex ?? "";
        message.backgroundImageUrl = object.backgroundImageUrl ?? "";
        message.videoContentUrl = object.videoContentUrl ?? "";
        message.logoImageUrl = object.logoImageUrl ?? "";
        message.waitingGraphicUrl = object.waitingGraphicUrl ?? "";
        message.staticExperienceIframeUrl = object.staticExperienceIframeUrl ?? "";
        return message;
    },
};
function createBaseUiConfig() {
    return { theme: undefined, perCharger: {}, receiptCallToAction: [] };
}
exports.UiConfig = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.theme !== undefined) {
            exports.Theme.encode(message.theme, writer.uint32(10).fork()).join();
        }
        globalThis.Object.entries(message.perCharger).forEach(([key, value]) => {
            exports.UiConfig_PerChargerEntry.encode({ key: key, value }, writer.uint32(18).fork()).join();
        });
        for (const v of message.receiptCallToAction) {
            exports.ReceiptCallToAction.encode(v, writer.uint32(26).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUiConfig();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.theme = exports.Theme.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    const entry2 = exports.UiConfig_PerChargerEntry.decode(reader, reader.uint32());
                    if (entry2.value !== undefined) {
                        message.perCharger[entry2.key] = entry2.value;
                    }
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.receiptCallToAction.push(exports.ReceiptCallToAction.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            theme: isSet(object.theme) ? exports.Theme.fromJSON(object.theme) : undefined,
            perCharger: isObject(object.perCharger)
                ? globalThis.Object.entries(object.perCharger).reduce((acc, [key, value]) => {
                    acc[key] = exports.PerChargerUiConfig.fromJSON(value);
                    return acc;
                }, {})
                : isObject(object.per_charger)
                    ? globalThis.Object.entries(object.per_charger).reduce((acc, [key, value]) => {
                        acc[key] = exports.PerChargerUiConfig.fromJSON(value);
                        return acc;
                    }, {})
                    : {},
            receiptCallToAction: globalThis.Array.isArray(object?.receiptCallToAction)
                ? object.receiptCallToAction.map((e) => exports.ReceiptCallToAction.fromJSON(e))
                : globalThis.Array.isArray(object?.receipt_call_to_action)
                    ? object.receipt_call_to_action.map((e) => exports.ReceiptCallToAction.fromJSON(e))
                    : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.theme !== undefined) {
            obj.theme = exports.Theme.toJSON(message.theme);
        }
        if (message.perCharger) {
            const entries = globalThis.Object.entries(message.perCharger);
            if (entries.length > 0) {
                obj.perCharger = {};
                entries.forEach(([k, v]) => {
                    obj.perCharger[k] = exports.PerChargerUiConfig.toJSON(v);
                });
            }
        }
        if (message.receiptCallToAction?.length) {
            obj.receiptCallToAction = message.receiptCallToAction.map((e) => exports.ReceiptCallToAction.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.UiConfig.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUiConfig();
        message.theme =
            object.theme !== undefined && object.theme !== null
                ? exports.Theme.fromPartial(object.theme)
                : undefined;
        message.perCharger = globalThis.Object.entries(object.perCharger ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = exports.PerChargerUiConfig.fromPartial(value);
            }
            return acc;
        }, {});
        message.receiptCallToAction =
            object.receiptCallToAction?.map((e) => exports.ReceiptCallToAction.fromPartial(e)) || [];
        return message;
    },
};
function createBaseUiConfig_PerChargerEntry() {
    return { key: "", value: undefined };
}
exports.UiConfig_PerChargerEntry = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            exports.PerChargerUiConfig.encode(message.value, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUiConfig_PerChargerEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.value = exports.PerChargerUiConfig.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value)
                ? exports.PerChargerUiConfig.fromJSON(object.value)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== undefined) {
            obj.value = exports.PerChargerUiConfig.toJSON(message.value);
        }
        return obj;
    },
    create(base) {
        return exports.UiConfig_PerChargerEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUiConfig_PerChargerEntry();
        message.key = object.key ?? "";
        message.value =
            object.value !== undefined && object.value !== null
                ? exports.PerChargerUiConfig.fromPartial(object.value)
                : undefined;
        return message;
    },
};
function createBaseChargerUiConfig() {
    return {
        theme: undefined,
        perCharger: undefined,
        receiptCallToAction: [],
        trackedLinkBaseUrl: "",
    };
}
exports.ChargerUiConfig = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.theme !== undefined) {
            exports.Theme.encode(message.theme, writer.uint32(10).fork()).join();
        }
        if (message.perCharger !== undefined) {
            exports.PerChargerUiConfig.encode(message.perCharger, writer.uint32(18).fork()).join();
        }
        for (const v of message.receiptCallToAction) {
            exports.ReceiptCallToAction.encode(v, writer.uint32(26).fork()).join();
        }
        if (message.trackedLinkBaseUrl !== "") {
            writer.uint32(34).string(message.trackedLinkBaseUrl);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChargerUiConfig();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.theme = exports.Theme.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.perCharger = exports.PerChargerUiConfig.decode(reader, reader.uint32());
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.receiptCallToAction.push(exports.ReceiptCallToAction.decode(reader, reader.uint32()));
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.trackedLinkBaseUrl = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            theme: isSet(object.theme) ? exports.Theme.fromJSON(object.theme) : undefined,
            perCharger: isSet(object.perCharger)
                ? exports.PerChargerUiConfig.fromJSON(object.perCharger)
                : isSet(object.per_charger)
                    ? exports.PerChargerUiConfig.fromJSON(object.per_charger)
                    : undefined,
            receiptCallToAction: globalThis.Array.isArray(object?.receiptCallToAction)
                ? object.receiptCallToAction.map((e) => exports.ReceiptCallToAction.fromJSON(e))
                : globalThis.Array.isArray(object?.receipt_call_to_action)
                    ? object.receipt_call_to_action.map((e) => exports.ReceiptCallToAction.fromJSON(e))
                    : [],
            trackedLinkBaseUrl: isSet(object.trackedLinkBaseUrl)
                ? globalThis.String(object.trackedLinkBaseUrl)
                : isSet(object.tracked_link_base_url)
                    ? globalThis.String(object.tracked_link_base_url)
                    : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.theme !== undefined) {
            obj.theme = exports.Theme.toJSON(message.theme);
        }
        if (message.perCharger !== undefined) {
            obj.perCharger = exports.PerChargerUiConfig.toJSON(message.perCharger);
        }
        if (message.receiptCallToAction?.length) {
            obj.receiptCallToAction = message.receiptCallToAction.map((e) => exports.ReceiptCallToAction.toJSON(e));
        }
        if (message.trackedLinkBaseUrl !== "") {
            obj.trackedLinkBaseUrl = message.trackedLinkBaseUrl;
        }
        return obj;
    },
    create(base) {
        return exports.ChargerUiConfig.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseChargerUiConfig();
        message.theme =
            object.theme !== undefined && object.theme !== null
                ? exports.Theme.fromPartial(object.theme)
                : undefined;
        message.perCharger =
            object.perCharger !== undefined && object.perCharger !== null
                ? exports.PerChargerUiConfig.fromPartial(object.perCharger)
                : undefined;
        message.receiptCallToAction =
            object.receiptCallToAction?.map((e) => exports.ReceiptCallToAction.fromPartial(e)) || [];
        message.trackedLinkBaseUrl = object.trackedLinkBaseUrl ?? "";
        return message;
    },
};
function createBaseCOSTCO() {
    return { offlineValidationFallbackTimeoutInSeconds: 0 };
}
exports.COSTCO = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.offlineValidationFallbackTimeoutInSeconds !== 0) {
            writer
                .uint32(8)
                .uint32(message.offlineValidationFallbackTimeoutInSeconds);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCOSTCO();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.offlineValidationFallbackTimeoutInSeconds = reader.uint32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            offlineValidationFallbackTimeoutInSeconds: isSet(object.offlineValidationFallbackTimeoutInSeconds)
                ? globalThis.Number(object.offlineValidationFallbackTimeoutInSeconds)
                : isSet(object.offline_validation_fallback_timeout_in_seconds)
                    ? globalThis.Number(object.offline_validation_fallback_timeout_in_seconds)
                    : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.offlineValidationFallbackTimeoutInSeconds !== 0) {
            obj.offlineValidationFallbackTimeoutInSeconds = Math.round(message.offlineValidationFallbackTimeoutInSeconds);
        }
        return obj;
    },
    create(base) {
        return exports.COSTCO.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCOSTCO();
        message.offlineValidationFallbackTimeoutInSeconds =
            object.offlineValidationFallbackTimeoutInSeconds ?? 0;
        return message;
    },
};
function createBaseDEMO() {
    return {};
}
exports.DEMO = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDEMO();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.DEMO.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseDEMO();
        return message;
    },
};
function createBaseMembershipValidation() {
    return { costco: undefined, demo: undefined };
}
exports.MembershipValidation = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.costco !== undefined) {
            exports.COSTCO.encode(message.costco, writer.uint32(10).fork()).join();
        }
        if (message.demo !== undefined) {
            exports.DEMO.encode(message.demo, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMembershipValidation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.costco = exports.COSTCO.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.demo = exports.DEMO.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            costco: isSet(object.costco) ? exports.COSTCO.fromJSON(object.costco) : undefined,
            demo: isSet(object.demo) ? exports.DEMO.fromJSON(object.demo) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.costco !== undefined) {
            obj.costco = exports.COSTCO.toJSON(message.costco);
        }
        if (message.demo !== undefined) {
            obj.demo = exports.DEMO.toJSON(message.demo);
        }
        return obj;
    },
    create(base) {
        return exports.MembershipValidation.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMembershipValidation();
        message.costco =
            object.costco !== undefined && object.costco !== null
                ? exports.COSTCO.fromPartial(object.costco)
                : undefined;
        message.demo =
            object.demo !== undefined && object.demo !== null
                ? exports.DEMO.fromPartial(object.demo)
                : undefined;
        return message;
    },
};
function createBaseBasicAuthentication() {
    return { username: "", password: "" };
}
exports.BasicAuthentication = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.username !== "") {
            writer.uint32(10).string(message.username);
        }
        if (message.password !== "") {
            writer.uint32(18).string(message.password);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBasicAuthentication();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.username = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.password = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            username: isSet(object.username)
                ? globalThis.String(object.username)
                : "",
            password: isSet(object.password)
                ? globalThis.String(object.password)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.username !== "") {
            obj.username = message.username;
        }
        if (message.password !== "") {
            obj.password = message.password;
        }
        return obj;
    },
    create(base) {
        return exports.BasicAuthentication.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBasicAuthentication();
        message.username = object.username ?? "";
        message.password = object.password ?? "";
        return message;
    },
};
function createBaseClientCertAuthentication() {
    return {
        clientCertificate: new Uint8Array(0),
        privateKey: new Uint8Array(0),
    };
}
exports.ClientCertAuthentication = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.clientCertificate.length !== 0) {
            writer.uint32(10).bytes(message.clientCertificate);
        }
        if (message.privateKey.length !== 0) {
            writer.uint32(18).bytes(message.privateKey);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseClientCertAuthentication();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.clientCertificate = reader.bytes();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.privateKey = reader.bytes();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientCertificate: isSet(object.clientCertificate)
                ? bytesFromBase64(object.clientCertificate)
                : isSet(object.client_certificate)
                    ? bytesFromBase64(object.client_certificate)
                    : new Uint8Array(0),
            privateKey: isSet(object.privateKey)
                ? bytesFromBase64(object.privateKey)
                : isSet(object.private_key)
                    ? bytesFromBase64(object.private_key)
                    : new Uint8Array(0),
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.clientCertificate.length !== 0) {
            obj.clientCertificate = base64FromBytes(message.clientCertificate);
        }
        if (message.privateKey.length !== 0) {
            obj.privateKey = base64FromBytes(message.privateKey);
        }
        return obj;
    },
    create(base) {
        return exports.ClientCertAuthentication.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseClientCertAuthentication();
        message.clientCertificate = object.clientCertificate ?? new Uint8Array(0);
        message.privateKey = object.privateKey ?? new Uint8Array(0);
        return message;
    },
};
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(globalThis.String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
function isObject(value) {
    return typeof value === "object" && value !== null;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
